import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.tryon');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-tryon',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.tryon/view.scss */
/* src/app/page.tryon/view.scss: no such file or directory */`],
})
export class PageTryonComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public fitTabs: any[] = [
        { key: 'basic', label: '기본 피팅', path: '/tryon' },
        { key: 'angles', label: '다각도 피팅', path: '/tryon/angles' }
    ];
    public currentFitTab: string = 'basic';
    public currentModeQueryParams: any = { mannequin_mode: 'without' };
    public genderOptions: any[] = [
        {
            key: 'female',
            label: '여성',
            shortLabel: '여',
            activeClass: 'border-rose-500 bg-rose-50 text-rose-800 ring-2 ring-rose-200 shadow-sm',
            inactiveClass: 'border-gray-200 bg-white text-gray-600 hover:border-rose-300 hover:bg-rose-50 hover:text-rose-700',
            activeBadgeClass: 'bg-rose-600 text-white',
            inactiveBadgeClass: 'bg-rose-50 text-rose-700 ring-1 ring-rose-200'
        },
        {
            key: 'male',
            label: '남성',
            shortLabel: '남',
            activeClass: 'border-sky-500 bg-sky-50 text-sky-800 ring-2 ring-sky-200 shadow-sm',
            inactiveClass: 'border-gray-200 bg-white text-gray-600 hover:border-sky-300 hover:bg-sky-50 hover:text-sky-700',
            activeBadgeClass: 'bg-sky-600 text-white',
            inactiveBadgeClass: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200'
        }
    ];
    public selectedGender: string = 'female';
    public garmentSlots: any[] = [
        { key: 'upper', label: '상의', name: '', preview: '', file: null, objectUrl: '' },
        { key: 'lower', label: '하의', name: '', preview: '', file: null, objectUrl: '' },
        { key: 'full', label: '원피스/세트', name: '', preview: '', file: null, objectUrl: '' }
    ];
    public resultUrl: string = '';
    public resultMode: string = '';
    public statusText: string = '';
    public garmentResultUrl: string = '';
    public garmentResultMode: string = '';
    public garmentStatusText: string = '';
    public generating: boolean = false;
    private readonly resultImageWidth: number = 750;
    private readonly resultImageHeight: number = 1000;

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnDestroy() {
        this.garmentSlots.forEach(slot => {
            if (slot.objectUrl) URL.revokeObjectURL(slot.objectUrl);
        });
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public get currentFitLabel() {
        const tab = this.fitTabs.find(item => item.key === this.currentFitTab);
        return tab ? tab.label : '기본 피팅';
    }

    public get shouldIgnoreMannequin() {
        return true;
    }

    private getGarmentSlot(type: string) {
        return this.garmentSlots.find(slot => slot.key === type);
    }

    public getGarmentPreview(type: string) {
        const slot = this.getGarmentSlot(type);
        return slot ? slot.preview : '';
    }

    public getGarmentName(type: string) {
        const slot = this.getGarmentSlot(type);
        return slot ? slot.name : '';
    }

    public get garmentSelectionLabel() {
        const labels = this.garmentSlots
            .filter(slot => !!slot.preview)
            .map(slot => slot.label);
        return labels.length ? labels.join(' + ') : '미등록';
    }

    public get genderSelectionLabel() {
        const option = this.genderOptions.find(item => item.key === this.selectedGender);
        return option ? option.label : '여성';
    }

    private hasSeparatedGarments() {
        return !!this.getGarmentPreview('upper') || !!this.getGarmentPreview('lower');
    }

    private hasFullGarment() {
        return !!this.getGarmentPreview('full');
    }

    public isSlotDisabled(type: string) {
        if (type === 'full') return this.hasSeparatedGarments();
        return this.hasFullGarment();
    }

    public isUploadDisabled(type: string) {
        return this.isSlotDisabled(type) || !!this.getGarmentPreview(type);
    }

    public async selectGender(gender: string) {
        if (this.generating || gender === this.selectedGender) return;
        if (!this.genderOptions.some(item => item.key === gender)) return;

        this.selectedGender = gender;
        this.resetResult();
        await this.service.render();
    }

    private getDisabledMessage(type: string) {
        if (type === 'full') return '상의 또는 하의가 등록되어 원피스/세트를 함께 올릴 수 없습니다.';
        return '원피스/세트가 등록되어 상의 또는 하의를 함께 올릴 수 없습니다.';
    }

    private resetResult() {
        this.resultUrl = '';
        this.resultMode = '';
        this.statusText = '';
        this.garmentResultUrl = '';
        this.garmentResultMode = '';
        this.garmentStatusText = '';
    }

    private clearSlot(slot: any) {
        if (!slot) return;
        if (slot.objectUrl) URL.revokeObjectURL(slot.objectUrl);
        slot.name = '';
        slot.preview = '';
        slot.file = null;
        slot.objectUrl = '';
    }

    private getSelectedGarmentTypes() {
        return this.garmentSlots
            .filter(slot => !!slot.preview)
            .map(slot => slot.key);
    }

    private getResultDownloadExtension(resultUrl: string) {
        const match = String(resultUrl || '').match(/^data:image\/([a-z0-9.+-]+);/i);
        if (!match) return 'png';

        const subtype = match[1].toLowerCase();
        if (subtype === 'jpeg') return 'jpg';
        if (subtype === 'svg+xml') return 'svg';
        return subtype.replace(/[^a-z0-9]+/g, '') || 'png';
    }

    private sanitizeDownloadPart(value: string, fallback: string) {
        const text = String(value || fallback || '이미지');
        const sanitized = text
            .replace(/[\\/:*?"<>|]+/g, '-')
            .replace(/\s*\+\s*/g, '-')
            .replace(/\s+/g, '')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
        return sanitized || fallback || '이미지';
    }

    private getResultDownloadName() {
        const gender = this.sanitizeDownloadPart(this.genderSelectionLabel, '성별');
        const garmentTypes = this.sanitizeDownloadPart(this.garmentSelectionLabel, '의류');
        const extension = this.getResultDownloadExtension(this.resultUrl);
        return `finestyle-${gender}-기본피팅-${garmentTypes}.${extension}`;
    }

    public downloadResult() {
        if (!this.resultUrl || this.generating) return;

        const link = document.createElement('a');
        link.href = this.resultUrl;
        link.download = this.getResultDownloadName();
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    private async optimizeImageFile(file: File): Promise<File> {
        const maxSize = 768;
        const recompressThreshold = 768 * 1024;
        if (!file.type || file.type.indexOf('image/') !== 0) return file;

        return await new Promise((resolve) => {
            const image = new Image();
            const objectUrl = URL.createObjectURL(file);
            let settled = false;
            const finish = (nextFile: File) => {
                if (settled) return;
                settled = true;
                URL.revokeObjectURL(objectUrl);
                resolve(nextFile);
            };

            image.onload = () => {
                const width = image.naturalWidth || image.width;
                const height = image.naturalHeight || image.height;
                const scale = Math.min(1, maxSize / Math.max(width, height));
                const shouldResize = scale < 1;
                const shouldRecompress = !!file.size && file.size > recompressThreshold;
                if (!width || !height || (!shouldResize && !shouldRecompress)) {
                    finish(file);
                    return;
                }

                const canvas = document.createElement('canvas');
                canvas.width = Math.round(width * scale);
                canvas.height = Math.round(height * scale);
                const context = canvas.getContext('2d');
                if (!context) {
                    finish(file);
                    return;
                }

                context.drawImage(image, 0, 0, canvas.width, canvas.height);
                const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                const extension = outputType === 'image/png' ? '.png' : '.jpg';
                const basename = file.name.replace(/\.[^.]+$/, '') || 'garment';
                canvas.toBlob((blob) => {
                    if (!blob || blob.size >= file.size) {
                        finish(file);
                        return;
                    }
                    finish(new File([blob], `${basename}${extension}`, {
                        type: outputType,
                        lastModified: file.lastModified
                    }));
                }, outputType, 0.82);
            };
            image.onerror = () => {
                finish(file);
            };
            image.src = objectUrl;
        });
    }

    public async onGarmentChange(event: any, type: string) {
        const input = event?.target;
        const file = input?.files?.[0];
        if (input) input.value = '';
        if (!file) return;

        const slot = this.getGarmentSlot(type);
        if (!slot) return;

        if (slot.preview) {
            await this.alert("재업로드하려면 먼저 기존 의류를 삭제해주세요.");
            return;
        }

        if (this.isSlotDisabled(type)) {
            await this.alert(this.getDisabledMessage(type));
            return;
        }

        if (!file.type || file.type.indexOf('image/') !== 0) {
            await this.alert("이미지 파일을 업로드해주세요.");
            return;
        }

        const uploadFile = await this.optimizeImageFile(file);
        this.clearSlot(slot);
        const objectUrl = URL.createObjectURL(file);
        slot.file = uploadFile;
        slot.name = file.name;
        slot.objectUrl = objectUrl;
        slot.preview = objectUrl;
        this.resetResult();
        await this.service.render();
    }

    public async clearGarment(type: string) {
        const slot = this.getGarmentSlot(type);
        if (!slot) return;

        this.clearSlot(slot);
        this.resetResult();
        await this.service.render();
    }

    private buildTryOnFormData(selectedTypes: string[], garmentTypes: string) {
        const fd = new FormData();
        fd.append('mannequin', this.selectedGender);
        fd.append('gender', this.selectedGender);
        fd.append('garment_types', garmentTypes);
        selectedTypes.forEach(type => {
            const slot = this.getGarmentSlot(type);
            if (slot?.file) fd.append(`garment_${type}`, slot.file);
        });
        return fd;
    }

    private async uploadTryOnResult(selectedTypes: string[], garmentTypes: string, ignoreMannequin: boolean = true) {
        const fd = this.buildTryOnFormData(selectedTypes, garmentTypes);
        fd.append('ignore_mannequin', ignoreMannequin ? '1' : '0');
        const ignoreQuery = `&ignore_mannequin=${ignoreMannequin ? '1' : '0'}`;
        const url = `${wiz.url('try_on')}?mannequin=${encodeURIComponent(this.selectedGender)}&gender=${encodeURIComponent(this.selectedGender)}&garment_types=${encodeURIComponent(garmentTypes)}${ignoreQuery}`;
        return await this.service.file.upload(url, fd);
    }

    private getBackgroundAssetUrl() {
        const gender = this.selectedGender === 'male' ? 'male' : 'female';
        return `/assets/mannequin/background/${gender}-full-background.jpg?v=20260601-background-force`;
    }

    private loadCanvasImage(src: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error('이미지를 불러오지 못했습니다.'));
            image.src = src;
        });
    }

    private drawCoverImage(context: CanvasRenderingContext2D, image: HTMLImageElement, width: number, height: number) {
        const sourceWidth = image.naturalWidth || image.width;
        const sourceHeight = image.naturalHeight || image.height;
        if (!sourceWidth || !sourceHeight) return;

        let sx = 0;
        let sy = 0;
        let sw = sourceWidth;
        let sh = sourceHeight;
        const sourceRatio = sourceWidth / sourceHeight;
        const targetRatio = width / height;
        if (sourceRatio > targetRatio) {
            sw = sourceHeight * targetRatio;
            sx = (sourceWidth - sw) / 2;
        } else if (sourceRatio < targetRatio) {
            sh = sourceWidth / targetRatio;
            sy = (sourceHeight - sh) / 2;
        }
        context.drawImage(image, sx, sy, sw, sh, 0, 0, width, height);
    }

    private buildBackgroundMask(data: Uint8ClampedArray, width: number, height: number) {
        const total = width * height;
        const like = new Uint8Array(total);
        const samples = [0, width - 1, (height - 1) * width, total - 1];
        let bgR = 0;
        let bgG = 0;
        let bgB = 0;
        samples.forEach(index => {
            const offset = index * 4;
            bgR += data[offset];
            bgG += data[offset + 1];
            bgB += data[offset + 2];
        });
        bgR = Math.round(bgR / samples.length);
        bgG = Math.round(bgG / samples.length);
        bgB = Math.round(bgB / samples.length);

        for (let index = 0; index < total; index += 1) {
            const offset = index * 4;
            const red = data[offset];
            const green = data[offset + 1];
            const blue = data[offset + 2];
            const channelMax = Math.max(red, green, blue);
            const channelMin = Math.min(red, green, blue);
            const luma = (red * 0.299) + (green * 0.587) + (blue * 0.114);
            const nearCorner = Math.abs(red - bgR) <= 42
                && Math.abs(green - bgG) <= 42
                && Math.abs(blue - bgB) <= 42
                && (Math.abs(red - bgR) + Math.abs(green - bgG) + Math.abs(blue - bgB)) <= 94;
            const lightStudioGray = luma >= 214
                && (channelMax - channelMin) <= 42
                && Math.abs(red - green) <= 24
                && blue >= green - 8;
            like[index] = nearCorner || lightStudioGray ? 1 : 0;
        }

        const visited = new Uint8Array(total);
        const mask = new Uint8Array(total);
        const queue = new Int32Array(total);
        let head = 0;
        let tail = 0;
        const enqueue = (index: number) => {
            if (index < 0 || index >= total || visited[index] || !like[index]) return;
            visited[index] = 1;
            mask[index] = 255;
            queue[tail] = index;
            tail += 1;
        };

        for (let x = 0; x < width; x += 1) {
            enqueue(x);
            enqueue((height - 1) * width + x);
        }
        for (let y = 0; y < height; y += 1) {
            enqueue(y * width);
            enqueue(y * width + width - 1);
        }

        while (head < tail) {
            const index = queue[head];
            head += 1;
            const x = index % width;
            if (x > 0) enqueue(index - 1);
            if (x < width - 1) enqueue(index + 1);
            if (index >= width) enqueue(index - width);
            if (index < total - width) enqueue(index + width);
        }

        return mask;
    }

    private buildSubjectMask(width: number, height: number) {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        const mask = new Uint8Array(width * height);
        if (!context) return mask;

        const cx = width / 2;
        const gender = this.selectedGender === 'male' ? 'male' : 'female';
        const selectedTypes = this.getSelectedGarmentTypes();
        const hasFullGarment = selectedTypes.indexOf('full') >= 0;
        const shoulderHalf = width * (gender === 'male' ? 0.24 : 0.20);
        const waistHalf = width * (gender === 'male' ? 0.16 : 0.13);
        const hipHalf = width * (gender === 'male' ? 0.17 : 0.19);
        const armHalf = width * (gender === 'male' ? 0.075 : 0.065);
        const y = (value: number) => height * value;

        context.fillStyle = '#fff';
        context.beginPath();
        context.ellipse(cx, y(0.135), width * 0.085, height * 0.090, 0, 0, Math.PI * 2);
        context.fill();
        if (hasFullGarment) {
            const fullShoulderHalf = width * (gender === 'male' ? 0.18 : 0.15);
            const hemHalf = width * (gender === 'male' ? 0.19 : 0.23);
            const armTopHalf = width * (gender === 'male' ? 0.040 : 0.034);
            const armBottomHalf = width * (gender === 'male' ? 0.034 : 0.028);
            context.beginPath();
            context.moveTo(cx - fullShoulderHalf - armTopHalf, y(0.225));
            context.lineTo(cx - fullShoulderHalf + armTopHalf, y(0.225));
            context.lineTo(cx - width * 0.120 + armBottomHalf, y(0.690));
            context.lineTo(cx - width * 0.120 - armBottomHalf, y(0.690));
            context.closePath();
            context.fill();
            context.beginPath();
            context.moveTo(cx + fullShoulderHalf - armTopHalf, y(0.225));
            context.lineTo(cx + fullShoulderHalf + armTopHalf, y(0.225));
            context.lineTo(cx + width * 0.120 + armBottomHalf, y(0.690));
            context.lineTo(cx + width * 0.120 - armBottomHalf, y(0.690));
            context.closePath();
            context.fill();
            context.beginPath();
            context.moveTo(cx - fullShoulderHalf, y(0.205));
            context.lineTo(cx + fullShoulderHalf, y(0.205));
            context.lineTo(cx + waistHalf * 1.10, y(0.500));
            context.lineTo(cx + hemHalf, y(0.855));
            context.lineTo(cx - hemHalf, y(0.855));
            context.lineTo(cx - waistHalf * 1.10, y(0.500));
            context.closePath();
            context.fill();
            context.fillRect(cx - width * 0.100, y(0.785), width * 0.080, height * 0.190);
            context.fillRect(cx + width * 0.020, y(0.785), width * 0.080, height * 0.190);
        } else {
            context.fillRect(cx - shoulderHalf - armHalf, y(0.220), armHalf * 2, height * 0.460);
            context.fillRect(cx + shoulderHalf - armHalf, y(0.220), armHalf * 2, height * 0.460);
            context.beginPath();
            context.moveTo(cx - shoulderHalf, y(0.195));
            context.lineTo(cx + shoulderHalf, y(0.195));
            context.lineTo(cx + waistHalf, y(0.510));
            context.lineTo(cx + hipHalf, y(0.665));
            context.lineTo(cx - hipHalf, y(0.665));
            context.lineTo(cx - waistHalf, y(0.510));
            context.closePath();
            context.fill();
            context.fillRect(cx - width * 0.125, y(0.615), width * 0.100, height * 0.360);
            context.fillRect(cx + width * 0.025, y(0.615), width * 0.100, height * 0.360);
        }

        const softCanvas = document.createElement('canvas');
        softCanvas.width = width;
        softCanvas.height = height;
        const softContext = softCanvas.getContext('2d');
        const alphaSource = softContext || context;
        if (softContext) {
            softContext.filter = 'blur(6px)';
            softContext.drawImage(canvas, 0, 0);
        }
        const alpha = alphaSource.getImageData(0, 0, width, height).data;
        for (let index = 0; index < mask.length; index += 1) {
            mask[index] = alpha[index * 4 + 3];
        }
        return mask;
    }

    private shouldApplyGeneratedBackground(sourceData: Uint8ClampedArray, backgroundData: Uint8ClampedArray, width: number, height: number) {
        const points = [
            0,
            width - 1,
            (height - 1) * width,
            width * height - 1,
            Math.floor(width / 2),
            (height - 1) * width + Math.floor(width / 2)
        ];
        let alphaTotal = 0;
        let lumaTotal = 0;
        let chromaTotal = 0;
        let diffTotal = 0;
        points.forEach(index => {
            const offset = index * 4;
            const red = sourceData[offset];
            const green = sourceData[offset + 1];
            const blue = sourceData[offset + 2];
            alphaTotal += sourceData[offset + 3];
            lumaTotal += (red * 0.299) + (green * 0.587) + (blue * 0.114);
            chromaTotal += Math.max(red, green, blue) - Math.min(red, green, blue);
            diffTotal += Math.abs(red - backgroundData[offset])
                + Math.abs(green - backgroundData[offset + 1])
                + Math.abs(blue - backgroundData[offset + 2]);
        });

        const count = Math.max(1, points.length);
        const averageAlpha = alphaTotal / count;
        const averageLuma = lumaTotal / count;
        const averageChroma = chromaTotal / count;
        const averageChannelDiff = diffTotal / (count * 3);
        if (averageAlpha < 245) return true;
        if (averageChannelDiff <= 18) return false;
        return averageLuma >= 204 && averageChroma <= 42;
    }

    private async applyGeneratedBackgroundUrl(sourceUrl: string): Promise<string> {
        try {
            const [source, background] = await Promise.all([
                this.loadCanvasImage(sourceUrl),
                this.loadCanvasImage(this.getBackgroundAssetUrl())
            ]);
            const width = this.resultImageWidth;
            const height = this.resultImageHeight;
            if (!width || !height) return sourceUrl;

            const sourceCanvas = document.createElement('canvas');
            sourceCanvas.width = width;
            sourceCanvas.height = height;
            const sourceContext = sourceCanvas.getContext('2d');
            if (!sourceContext) return sourceUrl;
            this.drawCoverImage(sourceContext, source, width, height);
            const sourceImage = sourceContext.getImageData(0, 0, width, height);

            const backgroundCanvas = document.createElement('canvas');
            backgroundCanvas.width = width;
            backgroundCanvas.height = height;
            const backgroundContext = backgroundCanvas.getContext('2d');
            if (!backgroundContext) return sourceUrl;
            this.drawCoverImage(backgroundContext, background, width, height);
            const backgroundImage = backgroundContext.getImageData(0, 0, width, height);
            if (!this.shouldApplyGeneratedBackground(sourceImage.data, backgroundImage.data, width, height)) {
                return sourceCanvas.toDataURL('image/png');
            }

            const subjectMask = this.buildSubjectMask(width, height);
            const output = sourceContext.createImageData(width, height);
            const total = width * height;
            for (let index = 0; index < total; index += 1) {
                const offset = index * 4;
                const keep = subjectMask[index];
                const replace = 255 - keep;
                output.data[offset] = Math.round((sourceImage.data[offset] * keep + backgroundImage.data[offset] * replace) / 255);
                output.data[offset + 1] = Math.round((sourceImage.data[offset + 1] * keep + backgroundImage.data[offset + 1] * replace) / 255);
                output.data[offset + 2] = Math.round((sourceImage.data[offset + 2] * keep + backgroundImage.data[offset + 2] * replace) / 255);
                output.data[offset + 3] = 255;
            }
            sourceContext.putImageData(output, 0, 0);
            return sourceCanvas.toDataURL('image/png');
        } catch (e) {
            return sourceUrl;
        }
    }

    private extractResultImageValue(value: any): string {
        if (!value) return '';
        if (Array.isArray(value)) {
            for (const item of value) {
                const text = this.extractResultImageValue(item);
                if (text) return text;
            }
            return '';
        }
        if (typeof value === 'object') {
            const keys = ['url', 'src', 'href', 'path', 'file', 'image_url', 'image', 'data', 'value'];
            for (const key of keys) {
                if (value[key] === value) continue;
                const text = this.extractResultImageValue(value[key]);
                if (text) return text;
            }
            return '';
        }
        return String(value || '').trim();
    }

    private normalizeResultImageUrl(value: any, mime: string = 'image/png') {
        let text = this.extractResultImageValue(value)
            .replace(/^['"]+|['"]+$/g, '')
            .replace(/&amp;/g, '&')
            .trim();
        if (!text) return '';

        const duplicatedAbsoluteUrl = text.match(/^https?:\/\/.+?(https?:\/\/.+)$/i);
        if (duplicatedAbsoluteUrl) {
            text = duplicatedAbsoluteUrl[1];
        }

        if (text === '[object Object]' || text === '[object Array]') return '';
        if (text.startsWith('data:') || text.startsWith('blob:')) return text;
        if (text.startsWith('http://') || text.startsWith('https://')) return text;
        if (text.startsWith('//')) return `${window.location.protocol}${text}`;

        const compact = text.replace(/\s+/g, '');
        // Raw JPEG base64 often starts with /9j, so check base64 before absolute-path handling.
        if (compact.length > 128 && /^[a-z0-9+/]+={0,2}$/i.test(compact)) {
            return `data:${mime || 'image/png'};base64,${compact}`;
        }

        if (text.startsWith('/')) return text;
        if (/^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?\//i.test(text)) return `https://${text}`;
        if (/^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(text)) return `/${text}`;
        if (text.indexOf('/') >= 0) return text;
        if (/\.(png|jpe?g|webp|gif)(\?.*)?$/i.test(text)) return `/${text}`;
        return '';
    }

    private getResultImageUrl(item: any) {
        const mime = item?.mime || 'image/png';
        const candidates = [
            item?.image,
            item?.url,
            item?.image_url,
            item?.src,
            item?.href,
            item?.path
        ];
        for (const candidate of candidates) {
            const resultUrl = this.normalizeResultImageUrl(candidate, mime);
            if (resultUrl) return resultUrl;
        }
        return '';
    }

    private normalizeUploadResponse(res: any) {
        if (typeof res !== 'string') return res || {};
        try {
            return JSON.parse(res);
        } catch (e) {
            return {
                code: 0,
                data: {
                    message: res
                }
            };
        }
    }

    private getResponseMessage(res: any, fallback: string = '이미지 생성에 실패했습니다.') {
        return res?.data?.message || res?.message || fallback;
    }

    private async applyResultResponse(res: any, target: string) {
        const data = res?.data || res || {};
        const imageUrl = this.getResultImageUrl(data);
        if (!imageUrl) {
            throw new Error(data?.message || '이미지 생성 결과를 불러오지 못했습니다.');
        }

        const mode = data?.mode === 'ai' ? 'AI' : (data?.mode === 'composite' ? '합성' : '샘플');
        const message = data?.message || '';

        if (target === 'garment') {
            this.garmentResultUrl = imageUrl;
            this.garmentResultMode = mode;
            this.garmentStatusText = message;
            return;
        }

        const backgroundApplied = data?.background_applied === true || data?.background_applied === 'true';
        let displayUrl = imageUrl;
        if (this.shouldIgnoreMannequin && !backgroundApplied) {
            displayUrl = await this.applyGeneratedBackgroundUrl(imageUrl);
        }

        this.resultUrl = displayUrl;
        this.resultMode = mode;
        this.statusText = message;
    }

    public async tryOn() {
        if (this.generating) return;

        const selectedTypes = this.getSelectedGarmentTypes();
        if (!selectedTypes.length) {
            await this.alert("의류를 업로드해주세요.");
            return;
        }

        this.generating = true;
        this.resultUrl = '';
        this.resultMode = '';
        this.statusText = '이미지 생성 중';
        this.garmentResultUrl = '';
        this.garmentResultMode = '';
        await this.service.render();

        const garmentTypes = selectedTypes.join(',');

        try {
            const res: any = this.normalizeUploadResponse(await this.uploadTryOnResult(selectedTypes, garmentTypes, this.shouldIgnoreMannequin));
            if (res?.code === 200 || this.getResultImageUrl(res?.data || res)) {
                await this.applyResultResponse(res, 'base');
            } else {
                await this.alert(this.getResponseMessage(res));
                this.statusText = '';
            }
        } catch (e: any) {
            await this.alert(e?.message || "이미지 생성에 실패했습니다.");
            this.statusText = '';
        }

        this.generating = false;
        await this.service.render();
    }
}

export default PageTryonComponent;